<template>

  <div class="home" v-bind:style="{backgroundImage:'url('+bgImg+')'}">
        <div class="logo">
          <img id="ld" src="../assets/img/logo.svg"/>
          <img id="lm" src="../assets/img/logo_m.png"/>
          </div>
          <div style="" class="whiteline"><img src="../assets/img/whiteline.svg"/></div>
        <div class="instablock">
          <p>
            Идея хорошего дизайна заключается в том, чтобы заставить остальных дизайнеров почувствовать себя идиотами, потому что это не их идея. 
            <br/><br/>
            <span>Френк Чимеро</span>
            <br/><br/>
          </p>
          <div class="insta_line">
            <div class="lin"></div>
          <a href="https://www.instagram.com/kalesiaa/" target="_blank"><img src="../assets/img/instalogo.svg"/></a>
          </div>
        </div>
        <div class="instadesk">
          <a href="https://www.instagram.com/kalesiaa/" target="_blank"><img src="../assets/img/instalogo.svg"/></a>
        </div>
  </div>
</template>

<script>
import axios from 'axios'
const urlInsta = 'https://andreykolesnikov.com/ajax/get_static.php'
export default {
  name: 'Index',
  data() {
    return {
      dataArr: [],
      h: 0,
      bgImg:''
    };
  },
  mounted() {
    axios.get(urlInsta).then(response => {
      this.dataArr = response.data
      //console.log(this.dataArr);
      if(window.innerWidth>758){
        this.bgImg=this.dataArr.DESC_BG;
      }
      else{
        this.bgImg=this.dataArr.MOB_BG;
      }
    });
    console.log(window.innerWidth);
    
  }
}
</script>